const returnNull = () => null;
export default returnNull;
